module.exports = __webpack_public_path__ + "img/ic_google.6a834649.png";